"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRolEchainConfigurationUnsafe = exports.isRolEchainConfiguration = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const isRolEchainConfiguration = (config) => {
    return (0, echain_shared_articles_1.isRolEchainUnion)(config.Kette);
};
exports.isRolEchainConfiguration = isRolEchainConfiguration;
const isRolEchainConfigurationUnsafe = (config) => {
    return (0, echain_shared_articles_1.isRolEchainUnionUnsafe)(config.Kette);
};
exports.isRolEchainConfigurationUnsafe = isRolEchainConfigurationUnsafe;
//# sourceMappingURL=RolEchainConfiguration.js.map